import VueI18n from 'vue-i18n'
// import Vue from 'vue'
import store from '../store'

Vue.use(VueI18n)

const i18n = new VueI18n({
    locale: store.state.lang, // 语言标识
    silentTranslationWarn: true //去掉警告
});


function setI18nLanguage(lang) {
    console.log("---------------------------->", lang);
    i18n.locale = lang
    //store.commit('res_lang', lang);
    return lang
}


export function loadLanguageAsync(l) {
    let cu = store.state.country;
    let lang = l;
    let langkey = `${lang}`;
    if (!store.state.loadedLanguages.includes(langkey)) {
        return import(`@/assets/lang/${langkey}`).then(msgs => {
            i18n.setLocaleMessage(langkey, msgs)
            store.state.loadedLanguages.push(langkey)
            return setI18nLanguage(langkey)
        })
    } else {
        setI18nLanguage(langkey);
    }
    return Promise.resolve(langkey)
}


export function reloadLanguageAsync() {
    let cu = store.state.country;
    let lang = store.state.lang;
    let langkey = `${lang}`;
    if (!store.state.loadedLanguages.includes(langkey)) {
        return import(`@/assets/lang/${langkey}`).then(msgs => {
            i18n.setLocaleMessage(langkey, msgs)
            store.state.loadedLanguages.push(langkey)
            return setI18nLanguage(langkey)
        })
    } else {
        setI18nLanguage(langkey);
    }
    return Promise.resolve(langkey)
}

export default i18n;


// WEBPACK FOOTER //
// ./src/utils/i18n.js